import { render, staticRenderFns } from "./allPermission.vue?vue&type=template&id=5982b2f2&scoped=true&"
import script from "./allPermission.vue?vue&type=script&lang=js&"
export * from "./allPermission.vue?vue&type=script&lang=js&"
import style0 from "./allPermission.vue?vue&type=style&index=0&id=5982b2f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5982b2f2",
  null
  
)

export default component.exports